import * as api from "../Api";

export const CurrentPrices = () => async (dispatch) => {
  try {
    const { data } = await api.fetchCurrentPrices();
    dispatch({ type: "GET_CURRENT_PRICES", payload: data });
  } catch (error) {}
};
